import React, { memo, useMemo } from 'react';
import { CheckboxThemes } from '../../libraries/CheckboxThemes';
import { TooltipPosition } from '../../libraries/Tooltips';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './Checkbox.scss';
const rootClassName = 'component-checkbox';

export interface CheckboxProps {
  'tooltip-position'?: TooltipPosition;
  'tooltip-text'?: string;
  disabled?: boolean;
  'aria-disabled'?: boolean;
  value?: boolean;
  onChange?: (value: boolean, evt: React.MouseEvent<HTMLElement>) => void;
  theme?: CheckboxThemes;
  tag?: 'button' | 'div';
}

function Checkbox(props: CheckboxProps) {
  const fProps = useMemo(() => {
    const handleClick = (evt: React.MouseEvent<HTMLElement>) => {
      if (!props.disabled) {
        props.onChange?.(!props.value, evt);
        evt.stopPropagation();
      }
    };
    const p: any = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        `${rootClassName}-${props.theme}`,
        `${rootClassName}-${props.value ? 'checked' : 'not'}`,
      ]),
      'aria-disabled': props.disabled || props['aria-disabled'],
      onClick: handleClick,
    };
    delete p.value;
    delete p.tag;
    delete p.onChange;
    delete p.theme;
    return p;
  }, [props]);

  if (props.tag === 'div') {
    return <div {...fProps} />;
  }
  return <button {...fProps} />;
}

Checkbox.defaultProps = {
  disabled: false,
  value: false,
  theme: 'primary',
};

export default memo(Checkbox);
